import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider, InputNumber } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined, DollarCircleOutlined } from '@ant-design/icons';
import FontAwesome from 'react-fontawesome';

import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { pagosRegistradosReadAction } from '../../../redux/finanzas/pagosRegistrados/actionCreator'

const dateFormat = 'YYYY-MM-DD';

const gridStyle = {
  width: '14%',
  textAlign: 'center',
  fontWeight: '400',
  color: '#2296F3',
  fontSize: '12px',
  minHeight: '60px',
  display: 'inline',
  margin: '0 10px 0 0px'

};

const iconStyle = {
  color: '#2296F3',

};

const PagosRegistradosMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const registro = useSelector(state => state.PagosRegistradosCrudReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams(); // Esta funcion nos ayuda a leer los parametros recibidos (en caso de exista)
  const [form] = Form.useForm();

  const [ showTape, setshowTape ] = useState( true )

  useEffect(() => {
    if (id) // Cuando se este editando un registro, tendremos un ID en los parametros, por lo tanto podremos buscar en el api este regsitro
      dispatch(pagosRegistradosReadAction(id));
    else {
      dispatch(pagosRegistradosReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) { // Cuando la llamada al API fue exitosa, ya tendremos el objecto en la variable "registro" y podemos pasar estos valores al formulario     
      registro.nombreCajero = registro.nombreCajero + " " + registro.paternoCajero + " " + registro.maternoCajero
      registro.nombrePaciente = registro.nombrePaciente + " " + registro.paternoPaciente + " " + registro.maternoPaciente
      registro.nombreDentista = registro.nombreDentista + " " + registro.paternoDentista + " " + registro.maternoDentista
      registro.nombreSucursal = registro.nombreSucursal + " " + registro.calleSucursal + " " + registro.numeroSucursal + " " + registro.coloniaSucursal + " " + registro. codigoSucursal
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async (values) => { };
  

  const showTap = (event) => {
    console.log("-------------showTap-----------");
    console.log(event);
    setshowTape(event);
  }

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/finanzas/pagos-registrados/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA PAGO REGISTRADO"
      />
      <Main>

        <Row gutter={15}>
          <Col xs={24}>
          <Form
          layout="vertical"
          size="small"
          form={form}
          onFinish={handleSubmit}
        >
              <RecordFormWrapper>
                <Cards headless >
                  <BasicFormWrapper>

                  <Card>
                       <Card.Grid style={gridStyle} onClick={ () => showTap(true) } >
                            <FontAwesome name="dollar" style={iconStyle} />  Comisiones
                       </Card.Grid>
                       <Card.Grid style={gridStyle} onClick={ () => showTap(false) }>
                            <FontAwesome name="credit-card" style={iconStyle} />  Detalle compra
                        </Card.Grid>
                  </Card>
                  
                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="fecha" label="Fecha registro:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="nombreCajero" label="Nombre cajero:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item>   

                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item name="nombreSucursal" label="Sucursal:">
                               <Input  style={{ width: '350px', margin: '0 7px' }}  disabled/>
                             </Form.Item>
                             <Form.Item name="telefonoPrincipalSucursal" label="Teléfono:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item>     

                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item name="monto" label="Monto:">
                            <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="nombreEstatusPago" label="Estatus pago:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item  label="Comisiones:"></Form.Item>
                            </Input.Group>
                      </Form.Item>       
                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item name="comisionBrutaClinicaMonto" label={<div><p style={{ fontSize: '13px'}}>Comisión bruta</p><p style={{ fontSize: '13px'}}>clinica monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionBrutaClinicaPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Comisión bruta</p><p style={{ fontSize: '13px'}}>clinica porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionBrutaActorMonto" label={<div><p style={{ fontSize: '13px'}}>Comisión bruta</p><p style={{ fontSize: '13px'}}>actor/doctor monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionBrutaActorPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Comisión bruta</p><p style={{ fontSize: '13px'}}>actor/doctor porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item>

                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item name="retencionClinicaMonto" label={<div><p style={{ fontSize: '13px'}}>Retención</p><p style={{ fontSize: '13px'}}>clinica monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="retencionClinicaPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Retención</p><p style={{ fontSize: '13px'}}>clinica porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="retencionActorMonto" label={<div><p style={{ fontSize: '13px'}}>Retención</p><p style={{ fontSize: '13px'}}>actor/doctor monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="retencionActorPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Retención</p><p style={{ fontSize: '13px'}}>actor/doctor porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape ? 'block' : 'none' }}>
                          <Input.Group compact>
                            <Form.Item name="comisionNetaClinicaMonto" label={<div><p style={{ fontSize: '13px'}}>Comisión neta</p><p style={{ fontSize: '13px'}}>clinica monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionNetaClinicaPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Comisión neta</p><p style={{ fontSize: '13px'}}>clinica porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionNetaActorMonto" label={<div><p style={{ fontSize: '13px'}}>Comisión neta</p><p style={{ fontSize: '13px'}}>actor/doctor monto:</p></div>}>
                                    <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="comisionNetaActorPorcentaje" label={<div><p style={{ fontSize: '13px'}}>Comisión neta</p><p style={{ fontSize: '13px'}}>actor/doctor porcentaje:</p></div>}>
                                  <Input style={{ width: '180px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      {/* formulario detalle compra */}
                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="tipoTransaccionNombre" label="Tipo transacción:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="nombrePaciente" label="Nombre paciente:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="telefonoPaciente" label="Teléfono:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="nombreDentista" label="Nombre dentista:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                              <Form.Item name="telefonoDentista" label="Teléfono:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 


                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="fechaEjecucionCompra" label="Fecha ejecución:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="nombreServicio" label="Nombre servicio:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="dienteCompra" label="Diente:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="tratamientoCompra" label="Tratamiento:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="proximoTratamiendo" label="Proximo tratamiento:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="subtotalCompra" label="Sub total:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="descuentoCompra" label="Descuentos:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="totalCompra" label="Total:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                      <Form.Item style={{ display: showTape == false ? 'block' : 'none' }}> 
                          <Input.Group compact>
                              <Form.Item name="abonosCompra" label="AbonosCompra:">
                               <Input style={{ width: '350px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                             <Form.Item name="saldoCompra" label="Saldo:">
                               <Input style={{ width: '250px', margin: '0 7px' }} disabled/>
                             </Form.Item>
                          </Input.Group>
                      </Form.Item> 

                  </BasicFormWrapper>

                  <br />
                  
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default PagosRegistradosMainForm;
